export default {
  absence: {
    absence: "Abwesenheit",
    absence_not_justified: "Unentschuldigte Abwesenheit",
    absence_waiting_for_validation: "In Bearbeitung",
    absences_not_justified: "Unentschuldigte Abwesenheiten",
    absences: "Abwesenheiten",
    course: "Kurs",
    company: "Unternehmen",
    add_notification: "Anwesenheitsbescheinigung-Benachrichtigung senden",
    add_event: "Ereignis hinzufügen",
    edit_event: "Ereignis bearbeiten",
    delete_event: "Ereignis löschen",
    delete_events: "Ereignisse löschen",
    delete_event_sub_title: "Möchten Sie dieses Ereignis wirklich löschen?",
    delete_events_sub_title: "Möchten Sie diese Ereignisse wirklich löschen?",
    delete_event_success: "Ereignis erfolgreich gelöscht!",
    copy_event_success: "Ereignis erfolgreich kopiert!",
    cut_event_success: "Ereignis erfolgreich ausgeschnitten!",
    delete_events_success: "Ereignisse erfolgreich gelöscht!",
    post_event: "Ereignis erfolgreich hinzugefügt!",
    list_planning: "Liste der Ereignisse",
    list_planning_search: "Ereignisse suchen",
    import_planning: "Planung importieren",
    import_planning_success: "Planung erfolgreich importiert!",
    export_planning: "Planung exportieren",
    export_planning_success: "Planung erfolgreich exportiert!",
    add_absence: "Abwesenheit(en) hinzufügen",
    edit_absence: "Abwesenheit bearbeiten",
    delete_absence: "Abwesenheit löschen",
    delete_absences: "Abwesenheiten löschen",
    delete_absence_sub_title: "Möchten Sie diese Abwesenheit wirklich löschen?",
    delete_absences_sub_title: "Möchten Sie diese Abwesenheiten wirklich löschen?",
    delete_absence_success: "Abwesenheit erfolgreich gelöscht!",
    copy_absence_success: "Abwesenheit erfolgreich kopiert!",
    cut_absence_success: "Abwesenheit erfolgreich ausgeschnitten!",
    delete_absences_success: "Abwesenheiten erfolgreich gelöscht!",
    post_absence: "Abwesenheit erfolgreich hinzugefügt!",
    list_absences: "Liste der Abwesenheiten",
    list_absences_search: "Abwesenheiten suchen",
    list_attendance_certificate: "Anwesenheitsbescheinigungen auflisten",
    attendance_certificate_export_confirmed: "Anwesenheitsbescheinigung erfolgreich exportiert!",
    list_of_attendance_certificate: "Liste der Anwesenheitsbescheinigungen",
    no_attendance_certificate_available: "Es ist noch keine Anwesenheitsbescheinigung vorhanden",
    no_attendance_certificate_available_for_month: "Es gibt keine Anwesenheitsbescheinigung für den Monat",
    download_certificate: "Bescheinigung herunterladen",
    import_absences: "Abwesenheiten importieren",
    import_absences_success: "Abwesenheiten erfolgreich importiert!",
    notification: "Bescheinigungsbenachrichtigung",
    absence_ask: "Antrag auf außerordentliche Abwesenheitsgenehmigung",
    display_apprentice_list: "Liste der anzeigen",
    hide_apprentice_list: "Liste der Auszubildenden ausblenden",
    training_detail: "Ausbildungsdetails anzeigen",
    apprentice_list: "Liste der",
    personnal_data: "Persönliche Daten",
    sheet_from: "Datenblatt von",
    event_moved_success: "Ereignis erfolgreich verschoben!",
    absence_moved_success: "Abwesenheit erfolgreich verschoben!",
    justify: "Entschuldigen",
    justify_many_absence: "Mehrere meiner Abwesenheiten entschuldigen",
    submit_proof: "Abwesenheitsnachweis einreichen",
    proof_downloaded: "Datei erfolgreich heruntergeladen",
    planning: "Ereignis",
    not_justify: "Unentschuldigt",
    justified: "Entschuldigt",
    in_progress: "In Bearbeitung",
    start_date: "Startdatum",
    end_date: "Enddatum",
    start_time: "Startzeit",
    end_time: "Endzeit",
    duration: "Dauer",
    type: "Typ",
    verify_date: "Bitte geben Sie die Daten ein, die dem eingereichten Nachweis entsprechen",
    linked_to_planning: "Diese Abwesenheit ist mit einem Ereignis verknüpft",
    already_exit: "Für diesen Zeitraum existiert bereits eine Abwesenheit",
    context_menu: {
      copy: "Kopieren",
      cut: "Ausschneiden",
      paste: "Einfügen",
      delete: "Löschen",
      modify: "Dieses Ereignis bearbeiten",
      modify_absence: "Diese Abwesenheit bearbeiten",
      add: "Ereignis hinzufügen",
      add_absence: "Abwesenheit hinzufügen",
    },
    actions: {
      planning: "Planungsverwaltung",
      absences: "Anwesenheitsverwaltung",
      options: "Optionen",
    },
    justification: {
      valid: {
        confirmation: "Möchten Sie diese Abwesenheit wirklich validieren?",
        success: "Abwesenheit erfolgreich validiert",
      },
      action: {
        unvalid: "Ungültig machen",
      },
      unvalid: "Nachweis ungültig",
      status: {
        waiting_for_validation: "Warte auf Validierung",
        to_verify: "Zu überprüfen",
        justify: "Meine Abwesenheit entschuldigen",
        justified: "Entschuldigt",
        download: "Abwesenheitsnachweis herunterladen",
        waiting_proof: "Warte auf Nachweis",
        invalid: "Begründung ungültig",
      },
      notify_apprentice: "Auszubildenden bei Ablehnung benachrichtigen",
    },
    verification: "Überprüfung der Abwesenheit",
    signature: {
      valid: "Validieren",
      unlock: "Entsperren",
      invalid: "Ungültig machen",
      title: "Anwesenheitsliste",
      former: "Ausbilder",
      lesson: "Kurs",
      establishment: "Einrichtung",
      component: "Komponente",
      address: "Adresse",
      confirmation: "Möchten Sie diese Anwesenheitsliste wirklich validieren?",
      already_validate: "Anwesenheitsliste validiert",
      reset: {
        title: "Abwesenheiten und Anwesenheiten zurücksetzen",
      },
      unlock_signature: {
        confirmation: "Möchten Sie diese Anwesenheitsliste wirklich entsperren?",
        success: "Anwesenheitsliste erfolgreich entsperrt!",
      },
      valid_all_signature: "Alle ausgewählten Anwesenheitslisten validieren",
      valid_all: {
        title: "Validierung der Anwesenheitslisten",
        confirmation: "Möchten Sie alle diese Anwesenheitslisten wirklich validieren?",
        success: "Anwesenheitslisten erfolgreich validiert!",
      },
      reset_absence: {
        confirmation: "Möchten Sie alle Abwesenheiten und Anwesenheiten dieses Ereignisses wirklich zurücksetzen?",
        subtitle: "Alle Auszubildenden werden in die Spalte 'Zu definieren' verschoben",
        success: "Abwesenheiten und Anwesenheiten erfolgreich zurückgesetzt!",
      },
      signed_at: "Unterzeichnet am:",
    },
    status: {
      title: "Status",
      absents: "Abwesende",
      to_be_defined: "Zu definieren",
      attendees: "Anwesende",
      cancel: "Sitzung abgesagt",
      all_present: "Alle bei der Sitzung anwesend",
      to_valid: "Anwesenheitsliste zu validieren",
      no_absence_or_presence: " (keine Abwesenheit oder Anwesenheit)",
      with_absence: "Sitzung mit Abwesenheiten validiert",
    },
    attendance_management: {
      title: "Anwesenheitsverwaltung",
      external_title: "Anwesenheitsverwaltung mit Unterschriftenliste",
      transfer_to: {
        absence: "Alle Auszubildenden in die Spalte Abwesende verschieben",
        attendance: "Alle Auszubildenden in die Spalte Anwesende verschieben",
      },
    },
    presence: {
      title: ({ plural }) => plural(["Anwesenheit", "Anwesenheiten"]),
    },
    reason: "Abwesenheitsgrund",
    config: {
      valid: {
        confirmation: "Möchten Sie diese Konfiguration wirklich validieren?",
        success: "Konfiguration erfolgreich validiert!",
      },
    },
    empty_unjustify: "Keine unentschuldigten Abwesenheiten",
  },
};
